import { css } from 'twin.macro'

export const gridSizing = css`
  grid-template-columns: repeat(auto-fit, minmax(max(23rem, 100%/3), 1fr)) !important;
`
